// utils/wordcount.ts
// Convert markup-heavy text into visible word counts so credits match user-facing output.
import { sanitizeRichTextHtml } from './sanitizeHtml';

export const WORD_COUNT_VERSION = 2;

function stripMarkup(text: string): string {
  const source = (text ?? '').trim();
  if (!source) return '';

  try {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const container = document.createElement('div');
      container.innerHTML = sanitizeRichTextHtml(source);
      container.querySelectorAll('script, style, noscript').forEach((el) => el.remove());
      const plain = container.textContent || '';
      return plain.replace(/\u00A0/g, ' ').replace(/\s+/g, ' ').trim();
    }
  } catch (err) {
    // Fallback to regex-based stripping below
  }

  // Remove script/style blocks and tags as a fallback (e.g. during SSR/tests)
  const withoutBlocks = source
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<noscript[\s\S]*?<\/noscript>/gi, ' ');
  const withoutTags = withoutBlocks.replace(/<[^>]+>/g, ' ');
  const withoutEntities = withoutTags
    .replace(/&nbsp;/gi, ' ')
    .replace(/&[#A-Za-z0-9]+;/g, ' ');
  return withoutEntities.replace(/\s+/g, ' ').trim();
}

export function countWordsIncludingMarkup(text: string | null | undefined): number {
  if (!text || typeof text !== 'string') return 0;
  try {
    const stripped = stripMarkup(text);
    if (!stripped) return 0;
    return stripped.split(/\s+/).filter(Boolean).length;
  } catch {
    return 0;
  }
}
